// extracted by mini-css-extract-plugin
export var columnItem = "_fb-3";
export var columnItemDraggable = "_fb-5";
export var dragHandle = "_fb-0";
export var dragHandleHovered = "_fb-1";
export var dropdown = "_fb-6";
export var dropdownContent = "_fb-8";
export var dropdownInner = "_fb-7";
export var filterDropdownHeader = "_fb-9";
export var icon = "_fb-2";
export var moveToTopButton = "_fb-4";
export var sectionDivider = "_fb-a";